//
// React
//
import React from 'react';

// Create a context for the reducer bound to that components tree
const ReducerContext = React.createContext(undefined);

export default ReducerContext;
